import React from "react";
import {
  Row,
  Box,
  Botao,
  Alerta,
  TipoAlerta,
  TipoBotao,
  Col,
} from "@intechprev/componentes-web";
import { RecadastramentoService, FormulariosService, PlanoService } from "../../services";
import { WebRecadParticipanteDadosEntidade, DependenteEntidade } from "../../entidades";

interface Props {
  Avancar: () => void;
  Voltar: () => void;
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  NumeroPassoAtual: number;
}

interface State {
  ListaDependente: Array<DependenteEntidade>;
}

export class Passo6 extends React.Component<Props, State> {
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      ListaDependente: new Array<DependenteEntidade>()
    };
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);

      const ListaDependente = await RecadastramentoService.BuscarDependentes();

      this.setState({
        ListaDependente
      });
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };


  Voltar = () => {
    this.props.Voltar();
  };

  Proximo = async (): Promise<any> => {
    try {
      await this.alerta.current.limparErros();
      this.props.Avancar();
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  GerarRelatorioDesignicaoBeneficiarioParticipanteAdmitido = async () => {
    try {
      await this.alerta.current!.limparErros();

      const relatorio = await FormulariosService.GetRelatorioDesignicaoBeneficiarioParticipanteAdmitido(false);

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "designacao_beneficiario_participante_admitido.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "designacao_beneficiario_participante_admitido.pdf");
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      const err: any = e;
      if (err.response) {
        await this.alerta.current!.adicionarErro(await err.response.data.text());
        console.error(await err.response.data.text());
        return;
      }
      await this.alerta.current!.adicionarErro(err);
      console.error(err);
    }
  };

  renderDependentes = () => {
    if (this.state.ListaDependente.length > 0) {
      const deps = this.state.ListaDependente.map((dep: DependenteEntidade, index: number) => {
        return (
          <tr key={index}>
            <td>{dep.NOME_DEP}</td>
            <td>{dep.CPF}</td>
            <td>{dep.DT_NASC_DEP}</td>
            <td>{dep.SEXO_DEP === "F" ? "FEMININO" : "MASCULINO"}</td>
            <td>{dep.DS_GRAU_PARENTESCO}</td>
            <td>{dep.PERC_PECULIO}</td>
          </tr>
        );
      });

      return (
        <table className={"table table-responsive"}>
          <thead>
            <tr>
              <th style={{ width: "250" }}>Nome</th>
              <th>CPF</th>
              <th style={{ width: "150" }}>Data de Nascimento</th>
              <th>Sexo</th>
              <th style={{ width: "150" }}>Grau de Parentesco</th>
              <th>% Pecúlio</th>
            </tr>
          </thead>
          <tbody>{deps}</tbody>
        </table>
      );
    }
    return <Alerta tipo={TipoAlerta.info} mensagem={"Nenhum beneficiário cadastrado."} />;
  };

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Beneficiários para Fins de Pecúlio`}>
        <Alerta
          tipo={TipoAlerta.info}
          mensagem={"Caso seja necessária a alteração dos beneficiários de Pecúlio Por Morte, por favor, preencher o formulário, imprimir e assiná-lo presencialmente na sede da Fundação. Diante da impossibilidade do comparecimento, a assinatura no documento deve ter firma reconhecida e enviada pelos Correios."}
        />

        {this.renderDependentes()}

        <Alerta tipo={TipoAlerta.danger} ref={this.alerta} />

        <Row>
          <Col>
            <Botao
              tipo={TipoBotao.success}
              titulo={"Designação de Beneficiários - Pecúlio"}
              usaLoading
              onClick={this.GerarRelatorioDesignicaoBeneficiarioParticipanteAdmitido}
            />
          </Col>
        </Row>

        <Botao onClick={this.Voltar} titulo={"Voltar"} className={"m-2"} tipo={TipoBotao.light} icone={"angle-double-left"} iconeDireita />

        <Botao onClick={this.Proximo} titulo={"Continuar"} icone={"angle-double-right"} iconeDireita />
      </Box>
    );
  }
}
